import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import TableTemplate, {
  IExtraTypeUIProps,
} from "../../TableTemplate/tableTemplate";
import TableUI from "./TableUI";
import { getCCOrderTable } from "src/Requests/ccOrder";
import {
  ICCOrderAddOrderFormValues,
  ICCOrderSearchParams,
  ICCOrderTableReport,
} from "src/Interfaces/ccOrder";
import { store } from "src/App/store";
import {
  setCCOrderEditRowValues,
  setCCOrderOrderFormValues,
  setCCOrderOrderTableFetchDataFlag,
} from "src/Features/CCOrder/ccOrderSlice";
import { useEffect } from "react";
import { Modal } from "src/Components";
import EditOrder from "src/Pages/CCOrder/EditOrder";
import { CCOrderTableAdditional } from "./Additional";
import { ExtraType } from "src/Interfaces/TableInterfaces";
import ChartSearchParamUI from "src/Pages/CoveredCall/ChartSearchParamUI";

interface IProps {
  searchParam: ICCOrderSearchParams;
  showHiddenCols: boolean;
}

const CCOrderTable = ({ searchParam, showHiddenCols }: IProps) => {
  const dispatch = useAppDispatch();
  const editRowValues = useAppSelector((store) => store).ccOrder
    .editOrderRowValues;
  const flag = useAppSelector((store) => store).ccOrder.orderTableFetchDataFlag;

  const getExtraTypeUI = ({
    headerName,
    extraType,
    row,
    cellType,
  }: IExtraTypeUIProps<ICCOrderTableReport>) => {
    switch (extraType) {
      case ExtraType.WithChart:
        return <ChartSearchParamUI {...{ row, headerName, cellType }} />;
      default:
        return <></>;
    }
  };

  useEffect(() => {
    if (!flag) return;
    setTimeout(() => {
      dispatch(setCCOrderOrderTableFetchDataFlag(false));
    }, 100);
  }, [flag]);

  const onTableRowClick = (row: ICCOrderTableReport) => {
    dispatch(
      setCCOrderOrderFormValues({
        ...store.getState().ccOrder.addOrderFormValues,
        coveredCallOrderBuyLegs: row?.coveredCallOrderBuyLegs,
        coveredCallOrderSellLeg: row?.coveredCallOrderSellLeg,
        coveredCallOrderType: row?.coveredCallOrderType,
        coveredCallPositionStrategyEnum: row?.coveredCallPositionStrategyEnum,
      } as ICCOrderAddOrderFormValues),
    );
  };

  return (
    <div className="overflow-auto order-table">
      {editRowValues ? (
        <Modal
          UI={<EditOrder isConditionId={false} />}
          onClose={() => dispatch(setCCOrderEditRowValues(null))}
        />
      ) : (
        <></>
      )}
      <TableTemplate<ICCOrderSearchParams, ICCOrderTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={getCCOrderTable}
        TableUI={({
          reports,
          onAction,
          setSortingType,
          sortingType,
          getExtraTypeUI,
        }) => (
          <TableUI
            AdditionalBody={CCOrderTableAdditional}
            reports={reports}
            onAction={onAction}
            onTableRowClick={onTableRowClick}
            sortingType={sortingType}
            setSortingType={setSortingType}
            refreshFlag={flag}
            withSelect
            showHiddenCols={showHiddenCols}
            getExtraTypeUI={getExtraTypeUI}
          />
        )}
        searchParameters={searchParam}
        showPageSize
        getExtraTypeUI={getExtraTypeUI}
      />
    </div>
  );
};

export default CCOrderTable;
